class CartItemEdit extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const item = this.closest('.cart-item');
      const selector = item.querySelector('[data-selling-plan-selector]');
      selector.classList.toggle('hidden')
    });
  }
}

customElements.define('cart-item-edit', CartItemEdit);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    // this.addEventListener('click', (event) => {
    //   event.preventDefault();
    //   const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    //   cartItems.updateQuantity(this.dataset.index, 0);

    // });

    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      // const result = await cartItems.updateQuantity(this.dataset.index, 0);
      
      const result = await cartItems.updateQuantity(this.dataset.index, 0, document.activeElement.getAttribute('name'), 0);
      console.log('result', result)
    
      const parsedResult = JSON.parse(result);
      const giftInCart = parsedResult.items.filter(i => i.properties['_source'] == 'Cart GWP' ).length > 0 ? true : false;
      const giftPrice = giftInCart ? parsedResult.items.filter(i => i.properties['_source'] == 'Cart GWP' )[0].line_price : null; 
  
  
      const updatedCartPrice = giftPrice && giftPrice !== 0 ? parsedResult.total_price - giftPrice : parsedResult.total_price;
      if( updatedCartPrice < Number(window.gwp.threshold) && giftInCart ){
        if ( cartItems.querySelector('.cart-items').querySelector('[data-gwp]') ){
          await cartItems.updateQuantity(cartItems.querySelector('.cart-items').querySelector('[data-gwp]').dataset.gwp, 0, document.activeElement.getAttribute('name'));
        }
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  // onChange(event) {
  //   // if (event.target.closest('quantity-input')) {
    // this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId, event.target.dataset.sellingPlanId, event.target.closest('[data-selling-plan-selector]'), event.target.dataset.sellingPlanTrack, event.target.closest('[data-selling-plan-selector]') ? event.target.closest('[data-selling-plan-selector]').querySelector('[data-item-json]') : null)
  //   // }
  // }


  async onChange(event) {
    const result = await this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId, event.target.dataset.sellingPlanId, event.target.closest('[data-selling-plan-selector]'), event.target.dataset.sellingPlanTrack, event.target.closest('[data-selling-plan-selector]') ? event.target.closest('[data-selling-plan-selector]').querySelector('[data-item-json]') : null);
    
    const parsedResult = JSON.parse(result);
    const giftInCart = parsedResult.items.filter(i => i.properties['_source'] == 'Cart GWP' ).length > 0 ? true : false;
    const giftPrice = giftInCart ? parsedResult.items.filter(i => i.properties['_source'] == 'Cart GWP' )[0].line_price : null; 


    const updatedCartPrice = giftPrice && giftPrice !== 0 ? parsedResult.total_price - giftPrice : parsedResult.total_price;
    if( updatedCartPrice < Number(window.gwp.threshold) && giftInCart ){
      if ( this.querySelector('.cart-items').querySelector('[data-gwp]') ){
        await this.updateQuantity(this.querySelector('.cart-items').querySelector('[data-gwp]').dataset.gwp, 0, document.activeElement.getAttribute('name'));
      }
    }
  }


  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  async updateQuantity(line, quantity, name, variantId, selling_plan, sellingPlanSelector, sellingPlanTrack, cartData) {
    let data = {
      line,
      quantity,
      selling_plan,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    }

    if (sellingPlanSelector) {
      data = {
        line,
        quantity,
        selling_plan,
        properties: {
          ...JSON.parse(cartData.textContent).properties,
          '_cart-subscription-upsell': sellingPlanTrack
        },
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      }
    }

    this.enableLoading(line);

    const body = JSON.stringify(data);

    const result = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }


        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        // const lineItem =
        //   document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        // if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        //   cartDrawerWrapper
        //     ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
        //     : lineItem.querySelector(`[name="${name}"]`).focus();
        // } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        //   trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        // } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
        //   trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        // }

        return state;
      })
      .catch((error) => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        console.log('error', error)
      })
      .finally(() => {
        this.disableLoading(line);
      });

    return result;
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
